/**
 * 时间相关工具函数
 */
import dayjs from 'dayjs';

/**
 * 时间格式化函数
 * @param {string} date 时间  如：2024-1-1 11:11:11 或 时间戳
 * @param {'default' | '-' |  '/' | '.' | '年月日' |  '月日' | '年'} type 类型
 * @param {boolean} zeroFillFlag  为是否数字补零，默认补零
 * @return {string} 时间字符串
 * @example
 * formatPast('2024-1-1 11:11:11'); // 3天前
 * formatPast('2023-11-1 11:11:11'); // 2个月前
 * formatPast('2015-07-10 21:32:01'); // 8年前
 * formatPast('2023-02-01 09:32:01', '-', false); // 2023-2-1
 * formatPast('2023.12.8 19:32:01', '/'); // 2023/12/08
 * formatPast('2023.12.8 19:32:01', '.'); // 2023.12.08
 * formatPast('2023/5/10 11:32:01', '年月日'); // 2023年05月10日
 * formatPast('2023/6/25 11:32:01', '月日', false); // 6月25日
 * formatPast('2023/8/08 11:32:01', '年'); // 2023年
 */
export function TimeFormatPast(date, type = 'default', zeroFillFlag = true) {
  // 定义countTime变量，用于存储计算后的数据
  let countTime;
  // 获取当前时间戳
  let time = new Date().getTime();
  // 转换传入参数为时间戳
  const afferentTime = new Date(date).getTime();

  // 当前时间戳 - 传入时间戳
  time = Number.parseInt(`${time - afferentTime}`);

  if (time < 10000) {
    // 10秒内
    return '刚刚';
  } else if (time < 60000) {
    // 超过10秒少于1分钟内
    countTime = Math.floor(time / 1000);

    return `${countTime}秒前`;
  } else if (time < 3600000) {
    // 超过1分钟少于1小时
    countTime = Math.floor(time / 60000);

    return `${countTime}分钟前`;
  } else if (time < 86400000) {
    // 超过1小时少于24小时
    countTime = Math.floor(time / 3600000);

    return `${countTime}小时前`;
  } else if (time >= 86400000 && type == 'default') {
    // 超过二十四小时（一天）且格式参数为默认"default"
    countTime = Math.floor(time / 86400000);

    // 大于等于365天
    if (countTime >= 365) {
      return `${Math.floor(countTime / 365)}年前`;
    }

    // 大于等于30天
    if (countTime >= 30) {
      return `${Math.floor(countTime / 30)}个月前`;
    }

    return `${countTime}天前`;
  } else {
    // 一天（24小时）以上且格式不为"default"则按传入格式参数显示不同格式
    // 数字补零
    const Y = new Date(date).getFullYear();
    const M = new Date(date).getMonth() + 1;
    const zeroFillM = M > 9 ? M : `0${M}`;
    const D = new Date(date).getDate();
    const zeroFillD = D > 9 ? D : `0${D}`;

    // 传入格式为"-" "/" "."
    if (type == '-' || type == '/' || type == '.') {
      return zeroFillFlag ? Y + type + zeroFillM + type + zeroFillD : Y + type + M + type + D;
    }

    // 传入格式为"年月日"
    if (type == '年月日') {
      return zeroFillFlag
        ? Y + type[0] + zeroFillM + type[1] + zeroFillD + type[2]
        : Y + type[0] + M + type[1] + D + type[2];
    }

    // 传入格式为"月日"
    if (type == '月日') {
      return zeroFillFlag ? zeroFillM + type[0] + zeroFillD + type[1] : M + type[0] + D + type[1];
    }

    // 传入格式为"年"
    if (type == '年') {
      return Y + type;
    }
  }
}

/**
 * 判断当前时间是否超过2024年1月
 * @param {string} val 时间字符串
 * @returns {boolean} - 如果当前时间超过2024年1月则返回 true，否则返回 false
 */
export function TimeIsPast(val) {
  const now = dayjs();
  const time = dayjs(val);

  return now.isAfter(time);
}

/**
 * 添加浏览量
 * 前端加数据的规则：
 * 1.探宝学堂——
 * 数据治理工程师：浏览量+5999，在学人数+599
 * 数据分析工程师：浏览量+3999，在学人数+399
 * AI大学：浏览量+19999，在学人数+999
 * 数据分析师面对面：浏览量+3999，在学人数+399
 * 大咖三分钟：浏览量+15999，点赞量+599，收藏量+59
 * 2.需求市场——
 * 所有项目：浏览量+3999，报名人数+3
 * 3.社区部落——
 * 知识城邦、互助问答所有帖子：浏览量+3999，点赞量+399，收藏量+39
 */
export const viewNum = {
  1: {
    view: 0,
    study: 0,
  },
  2: {
    view: 0,
    study: 0,
  },
  3: {
    view: 0,
    study: 0,
  },
  4: {
    view: 0,
    study: 0,
  },
  5: {
    view: 0,
    study: 0,
  },
  6: {
    view: 0,
    study: 0,
  },
  7: {
    view: 0,
    study: 0,
  },
  DK: {
    view: 0,
    like: 0,
    star: 0,
  },
  JHXS: {
    view: 0,
    user: 0,
  },
  BLOG: {
    view: 0,
    like: 0,
    star: 0,
  },
};
